import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DashboardModuleService } from '../../dashboard/services/dashboard-module.service';
import { Subject, takeUntil } from 'rxjs';
@Pipe({
  name: 'isBlocked',
  pure: false
})
@Injectable()
export class BlockedUserStatus implements PipeTransform {
  blockedUsers = [];
  destroy$ = new Subject<void>();
  constructor(private readonly dashboardService: DashboardModuleService) {
    this.dashboardService.userFollowerList()
    .pipe(takeUntil(this.destroy$))
    .subscribe((res: any) => {
      this.blockedUsers = res.blocked;
    });
  }

  transform(email: string): boolean {
    if (email && this.blockedUsers?.length) {
      const isBlocked = this.blockedUsers.filter((el) => el === email);
      if (isBlocked?.length) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
